module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb-nav"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/works"
    }
  }, [_vm._v("Works")])], 1)])]), _c('article', {
    staticClass: "article"
  }, [_c('h1', {
    staticClass: "headline page_headline"
  }, [_vm._v(_vm._s(_vm.filteredData.title))]), _vm._l((_vm.filteredData.picture), function(p) {
    return (p.id === '1') ? _c('div', [_c('img', {
      attrs: {
        "src": p.path,
        "alt": ""
      }
    })]) : _vm._e()
  }), _c('div', {
    staticClass: "works_detail-detail"
  }, [_c('p', {}, [_vm._v(_vm._s(_vm.filteredData.text))]), _c('p', {}, [_vm._v("制作年：" + _vm._s(_vm.filteredData.year))]), _c('p', {}, [_vm._v(_vm._s(_vm.filteredData.role))]), _c('p', {}, [_c('a', {
    attrs: {
      "href": _vm.filteredData.url,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.filteredData.urlTitle))])])]), _vm._l((_vm.filteredData.picture), function(p) {
    return (p.id !== '1') ? _c('div', [_c('img', {
      attrs: {
        "src": p.path,
        "alt": ""
      }
    })]) : _vm._e()
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35474404","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WorksDetail.vue
// module id = 37
// module chunks = 0